import React, { useState, useEffect, useRef } from 'react';
import { motion } from 'framer-motion'
import { useNavigate } from 'react-router-dom'
import {
  RECENT_EVENTS,
  SERVICES,
  TABS_CONTENT,
  TESTIMONIALS,
  FAQ_ITEMS
} from '../../Assets/data/common'
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay, Navigation } from "swiper/modules";
import { useInView } from "react-intersection-observer";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import CustomCarousel from '../../Utils/sectionHeader'
import { ArrowRight } from 'react-bootstrap-icons'
import PublicHeader from '../Header/PublicHeader'
import Footer from '../Footer'
import groupIcon from '../../Assets/img/icons/group.png';
import regionIcon from '../../Assets/img/icons/region.png';
import volunteerIcon from '../../Assets/img/icons/volunteer.png';
import committeeIcon from '../../Assets/img/icons/committee.png';
import trainingIcon from '../../Assets/img/icons/training.png';
import instituteIcon from '../../Assets/img/icons/institute.png';
import logo1 from '../../Assets/img/Campus and Partners/logo1.jpg';
import logo2 from '../../Assets/img/Campus and Partners/logo2.jpg';
import logo3 from '../../Assets/img/Campus and Partners/logo3.jpg';
import logo4 from '../../Assets/img/Campus and Partners/logo4.jpg';
import logo5 from '../../Assets/img/Campus and Partners/logo5.jpg';
import logo6 from '../../Assets/img/Campus and Partners/logo6.jpg';
import logo7 from '../../Assets/img/Campus and Partners/logo7.jpg';
import logo8 from '../../Assets/img/Campus and Partners/logo8.jpg';
import logo9 from '../../Assets/img/Campus and Partners/logo9.jpg';
import logo10 from '../../Assets/img/Campus and Partners/logo10.jpg';
import logo11 from '../../Assets/img/Campus and Partners/logo11.jpg';
import logo12 from '../../Assets/img/Campus and Partners/logo12.jpg';
import logo13 from '../../Assets/img/Campus and Partners/logo13.jpg';
import logo14 from '../../Assets/img/Campus and Partners/logo14.jpg';
import logo15 from '../../Assets/img/Campus and Partners/logo15.jpg';
import logo16 from '../../Assets/img/Campus and Partners/logo16.jpg';
import logo17 from '../../Assets/img/Campus and Partners/logo17.jpg';
import logo18 from '../../Assets/img/Campus and Partners/logo18.jpg';
import logo19 from '../../Assets/img/Campus and Partners/logo19.jpg';
import logo20 from '../../Assets/img/Campus and Partners/logo20.jpg';
import logo21 from '../../Assets/img/Campus and Partners/logo21.jpg';
import logo22 from '../../Assets/img/Campus and Partners/logo22.jpg';
import logo23 from '../../Assets/img/Campus and Partners/logo23.jpg';
import visit1 from '../../Assets/img/AcademicVisits/visit1.jpg';
import visit2 from '../../Assets/img/AcademicVisits/visit2.jpg';
import visit3 from '../../Assets/img/AcademicVisits/visit3.jpg';
import visit4 from '../../Assets/img/AcademicVisits/visit4.jpg';
import visit5 from '../../Assets/img/AcademicVisits/visit5.jpg';
import visit6 from '../../Assets/img/AcademicVisits/visit6.jpg';
import visit7 from '../../Assets/img/AcademicVisits/visit7.jpg';
import visit8 from '../../Assets/img/AcademicVisits/visit8.jpg';
import visit9 from '../../Assets/img/AcademicVisits/visit9.jpg';
import visit10 from '../../Assets/img/AcademicVisits/visit10.jpg';
import visit11 from '../../Assets/img/AcademicVisits/visit11.jpg';
import visit12 from '../../Assets/img/AcademicVisits/visit12.jpg';
import visit13 from '../../Assets/img/AcademicVisits/visit13.jpg';
import visit14 from '../../Assets/img/AcademicVisits/visit14.jpg';
import visit15 from '../../Assets/img/AcademicVisits/visit15.jpg';
import visit16 from '../../Assets/img/AcademicVisits/visit16.jpg';
import visit17 from '../../Assets/img/AcademicVisits/visit17.jpg';
import visit18 from '../../Assets/img/AcademicVisits/visit18.jpg';
import visit19 from '../../Assets/img/AcademicVisits/visit19.jpg';
import visit20 from '../../Assets/img/AcademicVisits/visit20.jpg';
import visit21 from '../../Assets/img/AcademicVisits/visit21.jpg';
import visit22 from '../../Assets/img/AcademicVisits/visit22.jpg';
import visit23 from '../../Assets/img/AcademicVisits/visit23.jpg';
import visit24 from '../../Assets/img/AcademicVisits/visit24.jpg';
import visit25 from '../../Assets/img/AcademicVisits/visit25.jpg';
import visit26 from '../../Assets/img/AcademicVisits/visit26.jpg';
import visit27 from '../../Assets/img/AcademicVisits/visit27.jpg';
import visit28 from '../../Assets/img/AcademicVisits/visit28.jpg';
import visit29 from '../../Assets/img/AcademicVisits/visit29.jpg';
import visit30 from '../../Assets/img/AcademicVisits/visit30.jpg';
import visit31 from '../../Assets/img/AcademicVisits/visit31.jpg';
import visit32 from '../../Assets/img/AcademicVisits/visit32.jpg';
import visit33 from '../../Assets/img/AcademicVisits/visit33.jpg';
import visit34 from '../../Assets/img/AcademicVisits/visit34.jpg';
import visit35 from '../../Assets/img/AcademicVisits/visit35.jpg';
import visit36 from '../../Assets/img/AcademicVisits/visit36.jpg';
import visit37 from '../../Assets/img/AcademicVisits/visit37.jpg';
import visit38 from '../../Assets/img/AcademicVisits/visit38.jpg';



const Home = () => {
  const [showAll, setShowAll] = useState(false)
  const [currentIndex, setCurrentIndex] = useState(0);
  const navigate = useNavigate()
  const [activeIndex, setActiveIndex] = useState(null)
  const visibleServices = showAll ? SERVICES : SERVICES.slice(0, 4)
  const [showHighlight, setShowHighlight] = useState(false)

  useEffect(() => {
    const carouselElement = document.getElementById('testimonialCarousel')
    if (carouselElement) {
      carouselElement.addEventListener('slide.bs.carousel', event => {
        setActiveIndex(event.to)
      })
    }
  }, [])

  const toggleAccordion = index => {
    setActiveIndex(activeIndex === index ? null : index)
  }

  const countAnimation = (start, end, duration, element, suffix) => {
    let startTimestamp = null
    const step = timestamp => {
      if (!startTimestamp) startTimestamp = timestamp
      const progress = Math.min((timestamp - startTimestamp) / duration, 1)
      const easeOut = t => 1 - Math.pow(1 - t, 3)
      const easedProgress = easeOut(progress)
      const value = Math.floor(easedProgress * (end - start) + start)
      element.innerHTML = value.toLocaleString() + suffix
      if (progress < 1) {
        window.requestAnimationFrame(step)
      }
    }
    window.requestAnimationFrame(step)
  }

  useEffect(() => {
    const elements = document.querySelectorAll('.count-up')
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const element = entry.target
            const end = parseInt(element.getAttribute('data-end'), 10)
            const suffix = element.getAttribute('data-suffix')
            countAnimation(0, end, 2000, element, suffix)
            observer.unobserve(element)
          }
        })
      },
      { threshold: 0.1 }
    )

    elements.forEach(element => {
      observer.observe(element)
    })

    return () => {
      elements.forEach(element => {
        observer.unobserve(element)
      })
    }
  }, [])



  useEffect(() => {
    const interval = setInterval(() => {
      nextSlide();
    }, 5000);

    return () => clearInterval(interval);
  }, [currentIndex]);

  const nextSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex + 1 >= TESTIMONIALS.length ? 0 : prevIndex + 1
    );
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex - 1 < 0 ? TESTIMONIALS.length - 1 : prevIndex - 1
    );
  };


  const [cardsToShow, setCardsToShow] = useState(window.innerWidth <= 768 ? 1 : 3);

  useEffect(() => {
    const handleResize = () => {
      setCardsToShow(window.innerWidth <= 768 ? 1 : 3);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);


  useEffect(() => {
    const timer = setTimeout(() => {
      setShowHighlight(true)
    }, 10000)
    return () => clearTimeout(timer) // Cleanup the timer
  }, [])



  const stats = [
    { icon: groupIcon, value: "500+", label: "Career Counsellors" },
    { icon: regionIcon, value: "4", label: "Regional Groups" },
    { icon: volunteerIcon, value: "40+", label: "Volunteers" },
    { icon: committeeIcon, value: "5", label: "Functional Committees" },
    { icon: trainingIcon, value: "60+", label: "Training Events / year" },
    { icon: instituteIcon, value: "15+", label: "Institution Visits / year" }
  ];

  const logos = [
    { id: 1, image: logo21 },
    { id: 2, image: logo1 },
    { id: 3, image: logo2 },
    { id: 4, image: logo3 },
    { id: 5, image: logo23 },
    { id: 6, image: logo9 },
    { id: 7, image: logo22 },
    { id: 8, image: logo4 },
    { id: 9, image: logo6 },
    { id: 10, image: logo10 },
    { id: 11, image: logo11 },
    { id: 12, image: logo12 },
    { id: 13, image: logo13 },
    { id: 14, image: logo14 },
    { id: 15, image: logo15 },
    { id: 16, image: logo16 },
    { id: 17, image: logo17 },
    { id: 18, image: logo18 },
    { id: 19, image: logo19 },
    { id: 20, image: logo20 },
    { id: 21, image: logo8 },
    { id: 22, image: logo5 },
    { id: 23, image: logo7 }
  ];

  const academicVisitImages = [
    visit1,
    visit2,
    visit3,
    visit4,
    visit5,
    visit6,
    visit7,
    visit8,
    visit9,
    visit10,
    visit11,
    visit12,
    visit13,
    visit14,
    visit15,
    visit16,
    visit17,
    visit18,
    visit19,
    visit20,
    visit21,
    visit22,
    visit23,
    visit24,
    visit25,
    visit26,
    visit27,
    visit28,
    visit29,
    visit30,
    visit31,
    visit32,
    visit33,
    visit34,
    visit35,
    visit36,
    visit37,
    visit38,

  ];

  const chunkArray = (array, size) => {
    const result = [];
    for (let i = 0; i < array.length; i += size) {
      result.push(array.slice(i, i + size));
    }
    return result;
  };

  const pages = chunkArray(logos, 4);

  const swiperRef = useRef(null);

  const {
    ref: partnersRef,
    inView: partnersInView,
  } = useInView({
    threshold: 0.7,
    triggerOnce: true,
  });

  useEffect(() => {
    if (!swiperRef.current) return;

    if (partnersInView) {
      swiperRef.current.slideTo(0, 0);

      const timer = setTimeout(() => {
        swiperRef.current.autoplay.start();
      }, 1000);

      return () => clearTimeout(timer);
    }
  }, [partnersInView]);

  const getVisibleTestimonials = () => {
    const result = [];
    for (let i = 0; i < cardsToShow; i++) {
      const index = (currentIndex + i) % TESTIMONIALS.length;
      result.push({ ...TESTIMONIALS[index], originalIndex: index });
    }
    return result;
  };

  const visibleTestimonials = getVisibleTestimonials();

  return (
    <>
      <PublicHeader />
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
        className='homepage'
      >
        {showHighlight && (
          <motion.div
            initial={{ x: 100, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            exit={{ x: 100, opacity: 0 }}
            className="fixed bottom-8 right-8 sm:fixed bottom-2 right-4 flex items-end justify-center z-50 p-3"
          >
            <div className="relative rounded-lg shadow-2xl p-6 max-w-sm w-full border-l-4 border-[#0d73b9]"
              style={{
                background: "linear-gradient(180deg, #0078BF 0%, #244183 100%)"
              }}
            >
              <button
                onClick={() => setShowHighlight(false)}
                className="absolute top-2 right-2 text-white hover:text-white"
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>

              <div className="flex items-center space-x-4">
                <div className="bg-white rounded-full p-3">
                  <svg className="w-6 h-6 text-[#0d73b9]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </div>
                <div>
                  <h3 className="font-bold text-white">Join WhatsApp Community!! </h3>
                  <p className="text-sm text-white">Certified Career Counsellors Only.</p>
                  <div>
                    <a
                      href="https://zfrmz.in/SIJmVXVlbuH8ENsTRVwx" target="_blank"
                      className="mt-2 text-sm font-semibold text-white hover:text-gray-700 flex items-center"
                    >
                      Register Now (Free) <ArrowRight className="ml-1" />
                    </a>
                  </div>
                </div>
                {/* <div>
                <h3 className="font-bold text-white">Join our free community now.</h3>
                <p className="text-sm text-white">Be a part of APCCI community!!</p>
                <div>
                <a
                  href="/membership/plans"
                  className="mt-2 text-sm font-semibold text-white hover:text-gray-700 flex items-center"
                >
                  View Membership Plans & Offers <ArrowRight className="ml-1" />
                </a>
                </div>   */}
              </div>
              </div>
            
          </motion.div>
        )}
        <CustomCarousel />

        {/* Stats Grid Section */}
        <section
          className="w-full"
          style={{ background: 'linear-gradient(135deg, #5ebeff 0%, #0072ff 100%)' }}
        >
          {/* Mobile View */}
          <div className="sm:hidden overflow-x-auto py-6 px-6 ">
            <div className="flex space-x-3 w-max">
              {[
                { icon: groupIcon, value: "500+", label: "Career Counsellors" },
                { icon: regionIcon, value: "4", label: "Regional Groups" },
                { icon: volunteerIcon, value: "40+", label: "Volunteers" },
                { icon: committeeIcon, value: "5", label: "Functional Committees" },
                { icon: trainingIcon, value: "60+", label: "Training Events / year" },
                { icon: instituteIcon, value: "15+", label: "Institutions Visit / year" }
              ].map((item, i) => (
                <div
                  key={i}
                  className="bg-white min-w-[120px] rounded-3xl py-2 px-2 flex-shrink-0 flex flex-col items-center justify-center transition-transform duration-200 hover:scale-105 hover:shadow-lg"
                >
                  <img src={item.icon} alt={item.label} className="w-9 h-9 mb-2" />
                  <p className="text-sm font-bold text-gray-800">{item.value}</p>
                  <p className="text-xs font-semibold text-gray-700 text-center leading-tight">{item.label}</p>
                </div>
              ))}
            </div>
          </div>
          {/* Desktop View */}
          <div className="hidden sm:grid grid-cols-6 gap-4 px-6 py-4">
            {[
              { icon: groupIcon, value: "500+", label: "Career Counsellors" },
              { icon: regionIcon, value: "4", label: "Regional Groups" },
              { icon: volunteerIcon, value: "40+", label: "Volunteers" },
              { icon: committeeIcon, value: "5+", label: "Functional Committees" },
              { icon: trainingIcon, value: "60+", label: "Training Events / year" },
              { icon: instituteIcon, value: "15+", label: "Institutions Visit / year" }
            ].map((item, i) => (
              <div
                key={i}
                className="bg-white rounded-[2rem] py-3 px-2 flex flex-col items-center justify-center transition-transform duration-200 hover:scale-105 hover:shadow-lg"
              >
                <img src={item.icon} alt={item.label} className="w-20 h-20 mb-2" />
                <p className="text-xl font-bold text-gray-800">{item.value}</p>
                <p className="text-sm font-semibold text-gray-700 text-center leading-tight">{item.label}</p>
              </div>
            ))}
          </div>
        </section>

        {/* News Strip Section */}
        <div
          style={{
            width: '100%',
            height: '70px',
            background: 'linear-gradient(180deg, #0078BF 0%, #244183 100%)',
            color: 'white',
            overflow: 'hidden',
            display: 'flex',
            alignItems: 'center',
            fontFamily: 'Arial, sans-serif',
            fontSize: '18px',
            position: 'relative',
            whiteSpace: 'nowrap',
          }}
        >
          <div
            style={{
              display: 'inline-flex',
              animation: 'scroll-left 30s linear infinite',
            }}
          >
            {/* Original content */}
            {[
              "🎓 Empowering 500+ Career Counsellors Nationwide",
              "🛡️ India’s Only Registered Non-profit for Career Counsellors",
              "🎯 United in Purpose, Unstoppable in Impact",
            ].map((text, idx) => (
              <div
                key={idx}
                style={{
                  paddingRight: '150px',
                  flexShrink: 0,
                }}
              >
                {text}
              </div>
            ))}

            {[
              "🎓 Empowering 500+ Career Counsellors Nationwide",
              "🛡️ India’s Only Registered Non-Profit for Career Counsellors",
              "🎯 United in Purpose, Unstoppable in Impact",
            ].map((text, idx) => (
              <div
                key={`dup1-${idx}`}
                style={{
                  paddingRight: '150px',
                  flexShrink: 0,
                }}
              >
                {text}
              </div>
            ))}

            {[
              "🎓 Empowering 500+ Career Counsellors Nationwide",
              "🛡️ India’s Only Registered Non-Profit for Career Counsellors",
              "🎯 United in Purpose, Unstoppable in Impact",
            ].map((text, idx) => (
              <div
                key={`dup2-${idx}`}
                style={{
                  paddingRight: '150px',
                  flexShrink: 0,
                }}
              >
                {text}
              </div>
            ))}
          </div>

          <style>{`
          @keyframes scroll-left {
            0% { transform: translateX(0); }
            100% { transform: translateX(-33.3333%); }
          }
          @media (max-width: 768px) {
            div[style*="height: 70px"] {
              height: 45px !important;
              font-size: 14px !important;
            }
          }
        `}</style>
        </div>

        {/* Tabbed Information Section */}
        <section className=' px-4 py-6 bg-[#F5F5F5] md:py-10  '>
          <h2 className='text-2xl font-bold text-center mb-12 md:text-4xl mb-10'>Our Values & Aspirations</h2>
          <div className='grid grid-cols-1 md:grid-cols-3 gap-8 max-w-8xl mx-auto   md:mx-12 mb-5 container'>
            {/* We Aim */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              className='bg-white p-6 rounded-lg text-start h-[350px] flex flex-col'
            >
              <div className='w-70 h-70  mb-4'>
                <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M74.375 37.0312H64.8281C63.4766 25.5938 54.4062 16.5234 42.9688 15.1719V5.625C42.9688 5.28125 42.6875 5 42.3438 5H37.6562C37.3125 5 37.0312 5.28125 37.0312 5.625V15.1719C25.5938 16.5234 16.5234 25.5938 15.1719 37.0312H5.625C5.28125 37.0312 5 37.3125 5 37.6562V42.3438C5 42.6875 5.28125 42.9688 5.625 42.9688H15.1719C16.5234 54.4062 25.5938 63.4766 37.0312 64.8281V74.375C37.0312 74.7188 37.3125 75 37.6562 75H42.3438C42.6875 75 42.9688 74.7188 42.9688 74.375V64.8281C54.4062 63.4766 63.4766 54.4062 64.8281 42.9688H74.375C74.7188 42.9688 75 42.6875 75 42.3438V37.6562C75 37.3125 74.7188 37.0312 74.375 37.0312ZM40 59.0625C29.4688 59.0625 20.9375 50.5312 20.9375 40C20.9375 29.4688 29.4688 20.9375 40 20.9375C50.5312 20.9375 59.0625 29.4688 59.0625 40C59.0625 50.5312 50.5312 59.0625 40 59.0625Z" fill="url(#paint0_linear_18_182)" />
                  <path d="M40 30.625C37.4922 30.625 35.1484 31.5938 33.375 33.375C31.6016 35.1484 30.625 37.4922 30.625 40C30.625 42.5078 31.6016 44.8516 33.375 46.625C35.1484 48.3906 37.5 49.375 40 49.375C42.5 49.375 44.8516 48.3984 46.625 46.625C48.3906 44.8516 49.375 42.5 49.375 40C49.375 37.5 48.3984 35.1484 46.625 33.375C44.8516 31.5938 42.5078 30.625 40 30.625Z" fill="url(#paint1_linear_18_182)" />
                  <defs>
                    <linearGradient id="paint0_linear_18_182" x1="40" y1="12.5" x2="40" y2="77.6667" gradientUnits="userSpaceOnUse">
                      <stop stop-color="#0078BF" />
                      <stop offset="1" stop-color="#244183" />
                    </linearGradient>
                    <linearGradient id="paint1_linear_18_182" x1="40" y1="30.625" x2="40" y2="51.875" gradientUnits="userSpaceOnUse">
                      <stop stop-color="#0078BF" />
                      <stop offset="1" stop-color="#244183" />
                    </linearGradient>
                  </defs>
                </svg>
              </div>
              <h3 className='text-2xl font-bold mb-4'>We Aim</h3>
              <p className='text-gray-600 leading-relaxed'>
                To nurture a community of<strong> Professional Career Counsellors</strong> to deliver quality <strong>Career Guidance Services</strong> to the future workforce, thereby contributing to<strong> Nation building</strong>.
              </p>
            </motion.div>

            {/* Our Approach */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.2 }}
              className='bg-white p-6 rounded-lg text-start h-[350px] flex flex-col '
            >
              <div className='w-70 h-70  mb-4'>
                <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M17.0325 6.01501L13.5125 9.53001L18.75 14.765L22.265 11.25L17.0325 6.01501ZM62.97 6.01501L57.7325 11.25L61.25 14.765L66.485 9.53251L62.97 6.01501ZM40 7.57501C39.175 7.58168 38.3417 7.63502 37.5 7.73502H37.425C27.285 8.89752 19.215 17.09 17.8125 27.185C16.6925 35.31 20.0425 42.6775 25.625 47.4225C27.9082 49.3716 29.4527 52.0458 30 54.9975V69.9975H35.7C36.57 71.49 38.1575 72.4975 40 72.4975C41.8425 72.4975 43.43 71.49 44.3 69.9975H50V59.9975H50.235V57.0275C50.235 53.3625 52.14 49.6675 55.235 46.795C59.375 42.65 62.5 36.7625 62.5 30C62.5 17.65 52.335 7.46001 40 7.57501ZM40 12.575C49.6625 12.44 57.5 20.35 57.5 30C57.5 35.235 55.075 39.845 51.7175 43.2L51.7975 43.28C48.4623 46.3578 46.3051 50.5025 45.6975 55H34.7625C34.2125 50.715 32.375 46.5675 28.9025 43.5925C24.485 39.8425 21.8525 34.1925 22.7325 27.8125C23.825 19.9375 30.215 13.605 38.045 12.7375C38.6915 12.6479 39.3425 12.5944 39.995 12.5775L40 12.575ZM5 30V35H12.5V30H5ZM67.5 30V35H75V30H67.5ZM18.75 50.235L13.515 55.4675L17.0325 58.985L22.2625 53.75L18.75 50.235ZM61.25 50.235L57.735 53.75L62.9675 58.985L66.485 55.4675L61.25 50.235ZM35 60H45V65H35V60Z" fill="url(#paint0_linear_18_188)" />
                  <path d="M37.25 41L36.85 37.8C36.6333 37.7167 36.4293 37.6167 36.238 37.5C36.0466 37.3833 35.859 37.2583 35.675 37.125L32.7 38.375L29.95 33.625L32.525 31.675C32.5083 31.5583 32.5 31.446 32.5 31.338V30.663C32.5 30.5543 32.5083 30.4417 32.525 30.325L29.95 28.375L32.7 23.625L35.675 24.875C35.8583 24.7417 36.05 24.6167 36.25 24.5C36.45 24.3833 36.65 24.2833 36.85 24.2L37.25 21H42.75L43.15 24.2C43.3666 24.2833 43.571 24.3833 43.763 24.5C43.955 24.6167 44.1423 24.7417 44.325 24.875L47.2999 23.625L50.0499 28.375L47.475 30.325C47.4916 30.4417 47.5 30.5543 47.5 30.663V31.337C47.5 31.4457 47.4833 31.5583 47.45 31.675L50.025 33.625L47.275 38.375L44.325 37.125C44.1416 37.2583 43.95 37.3833 43.75 37.5C43.55 37.6167 43.35 37.7167 43.15 37.8L42.75 41H37.25ZM40.05 34.5C41.0166 34.5 41.8416 34.1583 42.525 33.475C43.2083 32.7917 43.55 31.9667 43.55 31C43.55 30.0333 43.2083 29.2083 42.525 28.525C41.8416 27.8417 41.0166 27.5 40.05 27.5C39.0666 27.5 38.2373 27.8417 37.562 28.525C36.8866 29.2083 36.5493 30.0333 36.55 31C36.5506 31.9667 36.8883 32.7917 37.563 33.475C38.2376 34.1583 39.0666 34.5 40.05 34.5Z" fill="black" />
                  <path d="M37.25 41L36.85 37.8C36.6333 37.7167 36.4293 37.6167 36.238 37.5C36.0466 37.3833 35.859 37.2583 35.675 37.125L32.7 38.375L29.95 33.625L32.525 31.675C32.5083 31.5583 32.5 31.446 32.5 31.338V30.663C32.5 30.5543 32.5083 30.4417 32.525 30.325L29.95 28.375L32.7 23.625L35.675 24.875C35.8583 24.7417 36.05 24.6167 36.25 24.5C36.45 24.3833 36.65 24.2833 36.85 24.2L37.25 21H42.75L43.15 24.2C43.3666 24.2833 43.571 24.3833 43.763 24.5C43.955 24.6167 44.1423 24.7417 44.325 24.875L47.2999 23.625L50.0499 28.375L47.475 30.325C47.4916 30.4417 47.5 30.5543 47.5 30.663V31.337C47.5 31.4457 47.4833 31.5583 47.45 31.675L50.025 33.625L47.275 38.375L44.325 37.125C44.1416 37.2583 43.95 37.3833 43.75 37.5C43.55 37.6167 43.35 37.7167 43.15 37.8L42.75 41H37.25ZM40.05 34.5C41.0166 34.5 41.8416 34.1583 42.525 33.475C43.2083 32.7917 43.55 31.9667 43.55 31C43.55 30.0333 43.2083 29.2083 42.525 28.525C41.8416 27.8417 41.0166 27.5 40.05 27.5C39.0666 27.5 38.2373 27.8417 37.562 28.525C36.8866 29.2083 36.5493 30.0333 36.55 31C36.5506 31.9667 36.8883 32.7917 37.563 33.475C38.2376 34.1583 39.0666 34.5 40.05 34.5Z" fill="url(#paint1_linear_18_188)" />
                  <defs>
                    <linearGradient id="paint0_linear_18_188" x1="40" y1="6.01501" x2="40" y2="81.3618" gradientUnits="userSpaceOnUse">
                      <stop stop-color="#0078BF" />
                      <stop offset="1" stop-color="#244183" />
                    </linearGradient>
                    <linearGradient id="paint1_linear_18_188" x1="40" y1="21" x2="40" y2="43.6667" gradientUnits="userSpaceOnUse">
                      <stop stop-color="#0078BF" />
                      <stop offset="1" stop-color="#244183" />
                    </linearGradient>
                  </defs>
                </svg>
              </div>
              <h3 className='text-2xl font-bold mb-4'>Our Approach</h3>
              <p className='text-gray-600 leading-relaxed'>
                To empower and professionalise Career Counsellors through <strong>Training, Capacity building, Networking events, Research, Knowledge sharing, Policy making and Advocacy</strong>.
              </p>
            </motion.div>

            {/* Our Core Values */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.4 }}
              className='bg-white p-6 rounded-lg text-start h-[350px] flex flex-col '
            >
              <div className='w-70 h-70  mb-4'>
                <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M7.5 12.5V41.015L8.2025 41.7975L22.5 56.0925V70H37.5V55C37.51 54.8625 37.865 47.1125 31.405 42.9675C31.3875 42.9575 31.425 42.9 31.405 42.8925C31.3875 42.88 31.3475 42.9 31.33 42.8925C28.3675 40.9575 25.3125 39.3775 23.205 37.735C21.075 36.085 20 34.7175 20 32.5H15C15 36.5425 17.3625 39.61 20.0775 41.72C22.7925 43.83 25.9475 45.3825 28.5925 47.11H28.6725C32.675 49.62 32.5 54.9225 32.5 54.9225V65H27.5V53.985L26.7975 53.2025L12.5 38.9075V12.5H7.5ZM67.5 12.5V38.9075L53.2025 53.2025L52.5 53.985V65H47.5V54.8425C47.5 54.8425 47.325 49.6175 51.3275 47.11H51.4075C54.045 45.3825 57.2075 43.825 59.9225 41.7175C62.6375 39.6125 65 36.5425 65 32.5H60C60 34.7175 58.925 36.085 56.7975 37.735C54.6875 39.375 51.6325 40.955 48.6725 42.89C48.6525 42.9 48.6125 42.88 48.5925 42.89V42.97C42.1875 47.07 42.4925 54.7375 42.5 55V70H57.5V56.0925L71.7975 41.7975L72.5 41.015V12.5H67.5Z" fill="black" />
                  <path d="M7.5 12.5V41.015L8.2025 41.7975L22.5 56.0925V70H37.5V55C37.51 54.8625 37.865 47.1125 31.405 42.9675C31.3875 42.9575 31.425 42.9 31.405 42.8925C31.3875 42.88 31.3475 42.9 31.33 42.8925C28.3675 40.9575 25.3125 39.3775 23.205 37.735C21.075 36.085 20 34.7175 20 32.5H15C15 36.5425 17.3625 39.61 20.0775 41.72C22.7925 43.83 25.9475 45.3825 28.5925 47.11H28.6725C32.675 49.62 32.5 54.9225 32.5 54.9225V65H27.5V53.985L26.7975 53.2025L12.5 38.9075V12.5H7.5ZM67.5 12.5V38.9075L53.2025 53.2025L52.5 53.985V65H47.5V54.8425C47.5 54.8425 47.325 49.6175 51.3275 47.11H51.4075C54.045 45.3825 57.2075 43.825 59.9225 41.7175C62.6375 39.6125 65 36.5425 65 32.5H60C60 34.7175 58.925 36.085 56.7975 37.735C54.6875 39.375 51.6325 40.955 48.6725 42.89C48.6525 42.9 48.6125 42.88 48.5925 42.89V42.97C42.1875 47.07 42.4925 54.7375 42.5 55V70H57.5V56.0925L71.7975 41.7975L72.5 41.015V12.5H67.5Z" fill="url(#paint0_linear_18_197)" />
                  <path d="M35.2841 20.934H43.9658L39.8575 12.795H39.3924L35.2841 20.934ZM38.4622 39.305V23.2595H25.0909L38.4622 39.305ZM40.7877 39.305L54.1589 23.2595H40.7877V39.305ZM46.5237 20.934H54.5465L51.3296 14.5003C51.0454 13.9835 50.6646 13.5701 50.1871 13.2601C49.7096 12.95 49.1732 12.795 48.5779 12.795H42.493L46.5237 20.934ZM24.7034 20.934H32.7261L36.7569 12.795H30.672C30.0777 12.795 29.5418 12.95 29.0643 13.2601C28.5869 13.5701 28.2055 13.9835 27.9202 14.5003L24.7034 20.934Z" fill="black" />
                  <path d="M35.2841 20.934H43.9658L39.8575 12.795H39.3924L35.2841 20.934ZM38.4622 39.305V23.2595H25.0909L38.4622 39.305ZM40.7877 39.305L54.1589 23.2595H40.7877V39.305ZM46.5237 20.934H54.5465L51.3296 14.5003C51.0454 13.9835 50.6646 13.5701 50.1871 13.2601C49.7096 12.95 49.1732 12.795 48.5779 12.795H42.493L46.5237 20.934ZM24.7034 20.934H32.7261L36.7569 12.795H30.672C30.0777 12.795 29.5418 12.95 29.0643 13.2601C28.5869 13.5701 28.2055 13.9835 27.9202 14.5003L24.7034 20.934Z" fill="url(#paint1_linear_18_197)" />
                  <defs>
                    <linearGradient id="paint0_linear_18_197" x1="40" y1="12.5" x2="40" y2="77.6667" gradientUnits="userSpaceOnUse">
                      <stop stop-color="#0078BF" />
                      <stop offset="1" stop-color="#244183" />
                    </linearGradient>
                    <linearGradient id="paint1_linear_18_197" x1="39.6249" y1="12.795" x2="39.6249" y2="42.8396" gradientUnits="userSpaceOnUse">
                      <stop stop-color="#0078BF" />
                      <stop offset="1" stop-color="#244183" />
                    </linearGradient>
                  </defs>
                </svg>
              </div>
              <h3 className='text-2xl font-bold mb-4'>Our Core Values</h3>
              <ul className='text-gray-600 leading-relaxed text-left overflow-y-scroll'>
                <li className='mb-2'>•<strong>Integrity: </strong> Staying transparent by following ethical practices with honesty.</li>
                <li>•<strong>Professionalism</strong> Excellence and high standards of competence in career counselling.</li>
                <li>•<strong>Unbiased Guidance</strong> Fair, objective, and client-focused career guidance.</li>
                <li>•<strong>Holistic Approach</strong> Comprehensive guidance, addressing personal growth, aspirations, and well-being.</li>
                <li>•<strong>Innovation</strong> Continuously adapting and implementing new strategies in career counselling.</li>
              </ul>
            </motion.div>
          </div>
        </section>

        {/* Services Section */}
        <section className='py-16' style={{ background: "linear-gradient(180deg, #0078BF 0%, #244183 100%)" }}>
          <div className='px-4'>
            <div className='text-center mb-16'>
              <h2 className='text-4xl font-bold text-white mb-4'>
                Why Join APCCI
              </h2>
            </div>

            <div className='max-w-8xl mx-auto md:mx-12 container'>
              <div className='grid md:grid-cols-2 gap-8'>
                {visibleServices.slice(0, window.innerWidth <= 768 ? (showAll ? 4 : 2) : 4).map((service, index) => (
                  <motion.div
                    key={index}
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: index * 0.1 }}
                    className='bg-white overflow-hidden shadow-lg md:flex flex-col md:flex-row'
                    style={{ borderRadius: "20px" }}
                  >
                    <div className='md:w-2/4 h-[200px] relative'>
                      <img
                        src={service.image}
                        alt={service.title}
                        className='w-full h-full object-cover p-3'
                        style={{ borderRadius: "30px" }}
                      />
                    </div>
                    <div className='md:w-3/5 p-6'>
                      <h3 className='text-xl font-bold text-gray-800 mb-2'>
                        {service.title}
                      </h3>
                      <p className='text-gray-600 text-sm mb-4'>
                        {service.description}
                      </p>
                      <div className='flex justify-start'>
                        <button
                          className='text-[#0d73b9] text-sm font-medium hover:text-blue-700 transition-colors flex items-center'
                          onClick={() => navigate(`/about/how-we-empowers-you`)}
                        >
                          Learn More
                          <ArrowRight className='ml-2' />
                        </button>
                      </div>
                    </div>
                  </motion.div>
                ))}
              </div>
              {window.innerWidth <= 768 && visibleServices.length > 2 && (
                <div className='mt-8 text-center'>
                  <button
                    onClick={() => setShowAll(!showAll)}
                    className='bg-white text-[#0d73b9] px-6 py-2 rounded-full font-medium hover:bg-opacity-90 transition-all flex items-center mx-auto'
                  >
                    {showAll ? 'See Less' : 'See More'}
                    <ArrowRight className={`ml-2 transition-transform ${showAll ? 'rotate-180' : ''}`} />
                  </button>
                </div>
              )}
            </div>
          </div>
        </section>

        {/* Testimonial Cards */}
        <section className='pt-10 bg-[#F5F5F5] ' style={{ borderRadius: "18px" }}>
          <div className="container mx-auto px-4 sm:px-0 md:px-4 max-w-8xl">
            <h2 className='text-4xl font-bold text-center mb-20'>
              <span className="text-black">What Makes Us Proud:</span> <span className="text-[#0078BF]">Our Members' Journeys</span>
            </h2>


            {/* Testimonial Cards */}
            <div className="relative">
              <div className="flex justify-between">
                {visibleTestimonials.map((testimonial, idx) => (
                  <div key={idx} className="w-full md:w-2/3 px-4  relative">
                    <div className="bg-white  shadow-md overflow-hidden " style={{ borderRadius: "20px" }}>
                      {/* Image */}
                      <div className="w-full flex justify-center pt-4 top-[-75px] absolute left-0 ">
                        <div className="w-24 h-24 rounded-full overflow-hidden">
                          <img
                            src={testimonial.image}
                            alt={testimonial.name}
                            className="w-full h-full object-cover"
                          />
                        </div>
                      </div>

                      {/* Details */}
                      <div className="p-6 mt-10 ">
                        <h3 className="text-xl font-bold text-center">{testimonial.name}</h3>
                        <p className="text-gray-600 text-center">{testimonial.role}</p>
                        <p className="text-gray-600 text-center">
                          {testimonial.organization ? testimonial.organization : <span>&nbsp;</span>}
                        </p>

                        {/* Testimonial Text */}
                        <div className="mt-4 border-t pt-4 ">
                          <p className="text-gray-600 text-justify overflow-y-scroll h-[150px]" style={{ textWrap: 'pretty' }}>
                            {testimonial.quote}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              {/* Navigation Buttons */}
              <div className=" left-0 right-0 bottom-0 flex justify-center mt-4 space-x-4 gap-20">
                <button
                  onClick={nextSlide}
                  className="w-12 h-12 flex items-center justify-center rounded-full bg-white shadow-md border border-gray-200 text-blue-500 hover:bg-gray-50 transition-colors duration-200"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="w-6 h-6">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                  </svg>
                </button>
                <button
                  onClick={prevSlide}
                  className="w-12 h-12 flex items-center justify-center rounded-full bg-white shadow-md border border-gray-200 text-blue-500 hover:bg-gray-50 transition-colors duration-200"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="w-6 h-6">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </button>
              </div>
            </div>

            {/* Call to action button */}
            <div className="flex justify-center mt-16">
              <button className="px-8 py-3  text-white font-bold  shadow-lg hover:bg-blue-700 transition duration-300" style={{ background: " linear-gradient(180deg, #0078BF 0%, #244183 100%)", borderRadius: "20px" }}
                onClick={() => navigate(`/membership/plans`)}>
                Start Your Journey
              </button>
            </div>
          </div>
          <div className="w-3/4 max-w-2xl h-[2px] mx-auto mt-14 rounded-sm bg-gradient-to-r from-[#0078BF] to-[#244183]"></div>

        </section>


        {/* Partners Section */}
        <section
          ref={partnersRef}
          className="bg-[#F5F5F5] py-4 md:py-10"
        >
          <div className="px-4">

            <div className="text-center mb-8 md:mb-16">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-3 md:mb-4 mt-3">
                Campus Visits & Knowledge Partners
              </h2>

              <p className="text-gray-600 text-base md:text-lg max-w-2xl mx-auto">
                Trusted by leading universities, institutions and industry partners across India.
              </p>
            </div>

            {/* Desktop & Tablet */}
            <div className="hidden md:grid grid-cols-4 lg:grid-cols-5 gap-8 max-w-7xl mx-auto">
              {logos.map((logo, index) => (
                <motion.div
                  key={logo.id}
                  initial={{ opacity: 0, y: 40 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, amount: 0.3 }}
                  transition={{
                    duration: 0.5,
                    delay: index * 0.08,
                    ease: "easeOut",
                  }}
                  className="group relative overflow-hidden bg-white rounded-2xl h-36 flex items-center justify-center p-6 border border-gray-200 shadow-sm hover:shadow-2xl hover:border-[#0078BF] hover:-translate-y-2 transition-all duration-500 cursor-pointer"
                >
                  {/* Shine Effect */}
                  <span className="absolute inset-0 -translate-x-full group-hover:translate-x-full transition-transform duration-700 bg-gradient-to-r from-transparent via-white/50 to-transparent skew-x-12"></span>

                  <img
                    src={logo.image}
                    alt="Partner Logo"
                    className="relative z-10 max-h-20 w-full object-contain transition-transform duration-500 group-hover:scale-110"
                  />
                </motion.div>
              ))}
            </div>

            {/* Mobile */}
            <div className="md:hidden">
              <Swiper
                onSwiper={(swiper) => (swiperRef.current = swiper)}
                modules={[Pagination, Autoplay]}
                loop
                pagination={{ clickable: true }}
                speed={700}
                spaceBetween={16}
                autoplay={{
                  delay: 2800,
                  disableOnInteraction: false,
                  pauseOnMouseEnter: true,
                }}
                style={{
                  paddingBottom: "35px",
                  "--swiper-pagination-color": "#0078BF",
                  "--swiper-pagination-bullet-inactive-color": "#D1D5DB",
                  "--swiper-pagination-bullet-inactive-opacity": "1",
                }}
              >
                {pages.map((page, index) => (
                  <SwiperSlide key={index}>

                    <div className="grid grid-cols-2 gap-4">
                      {page.map((logo) => (
                        <div
                          key={logo.id}
                          className="group relative overflow-hidden bg-white rounded-2xl h-28 flex items-center justify-center p-4 border border-gray-200 shadow-sm transition-all duration-300 hover:border-[#0078BF]"
                        >
                          <span className="absolute inset-0 -translate-x-full group-hover:translate-x-full transition-transform duration-700 bg-gradient-to-r from-transparent via-white/50 to-transparent skew-x-12"></span>

                          <img
                            src={logo.image}
                            alt="Partner Logo"
                            className="relative z-10 max-h-14 w-full object-contain transition-transform duration-300 group-hover:scale-105"
                          />
                        </div>
                      ))}
                    </div>
                  </SwiperSlide>

                ))}
              </Swiper>
            </div>

          </div>
          <div className="w-3/4 max-w-2xl h-[2px] mx-auto mt-14 rounded-sm bg-gradient-to-r from-[#0078BF] to-[#244183]"></div>
        </section>


        {/* Academic Exploration Visits Section */}
        <section className="bg-[#F5F5F5] py-6 md:py-12 overflow-hidden">
          <div className="px-4">

            {/* Heading */}
            <div className="text-center mb-8 md:mb-12">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-3 md:mb-4">
                Academic Exploration Visits
              </h2>

              <p className="text-gray-600 text-base md:text-lg max-w-2xl mx-auto">
                Learning Beyond Zoom Rooms...
              </p>
            </div>

            {/* Gallery Carousel */}
            <div className="max-w-7xl mx-auto">
              <Swiper
                modules={[Autoplay, Pagination, Navigation]}
                spaceBetween={20}
                slidesPerView={1}
                loop={true}
                speed={800}

                autoplay={{
                  delay: 4000,
                  disableOnInteraction: false,
                  pauseOnMouseEnter: true,
                }}

                pagination={{
                  clickable: true,
                  dynamicBullets: true,
                }}

                navigation={true}

                breakpoints={{
                  640: {
                    slidesPerView: 1,
                    spaceBetween: 18,
                  },

                  768: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                  },

                  1024: {
                    slidesPerView: 3,
                    spaceBetween: 24,
                  },
                }}

                style={{
                  paddingBottom: "45px",

                  "--swiper-pagination-color": "#0078BF",

                  "--swiper-pagination-bullet-inactive-color": "#9CA3AF",

                  "--swiper-pagination-bullet-inactive-opacity": "0.5",

                  "--swiper-navigation-color": "#ffffff",

                  "--swiper-navigation-size": "20px",
                }}
              >
                {academicVisitImages.map((image, index) => (
                  <SwiperSlide key={index}>

                    <div
                      className="
                group
                relative
                overflow-hidden
                rounded-2xl
                bg-white
                shadow-md
                cursor-pointer
              "
                    >
                      {/* Image */}
                      <div className="aspect-[4/3] overflow-hidden">
                        <img
                          src={image}
                          alt={`Academic Exploration Visit ${index + 1}`}
                          loading="lazy"
                          className="
                    w-full
                    h-full
                    object-cover
                    transition-transform
                    duration-700
                    ease-out
                    group-hover:scale-105
                  "
                        />
                      </div>

                      {/* Subtle Hover Overlay */}
                      <div
                        className="
                  absolute
                  inset-0
                  bg-black/0
                  group-hover:bg-black/10
                  transition-all
                  duration-500
                  pointer-events-none
                "
                      />

                    </div>

                  </SwiperSlide>
                ))}
              </Swiper>
            </div>

          </div>
        </section>
        {/* Past Events Section - Replacing Upcoming Events
        <section className='bg-[#F5F5F5] py-4 md:py-10'>
        <div className='px-4'>
          <div className='text-center mb-8 md:mb-16'>
            <h2 className='text-3xl md:text-4xl font-bold text-gray-800 mb-3 md:mb-4 mt-3'>Past Events</h2>
            <p className='text-gray-600 text-base md:text-lg max-w-2xl mx-auto'>
              Discover our latest gatherings and stay connected with the community
            </p>
          </div>

          <div className='grid gap-6 md:gap-8 max-w-8xl md:mx-12 container mx-auto'>
            {RECENT_EVENTS.slice(0, window.innerWidth <= 768 ? (showAll ? 4 : 2) : 4).map((event, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 }}
                whileHover={{
                  scale: window.innerWidth > 768 ? 1.03 : 1,
                  transition: { duration: 0.2 }
                }}
                className='bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow flex flex-col md:flex-row'
              >
                <div className={`w-full ${index % 2 !== 0 ? 'md:order-2' : ''} md:w-2/4 h-[200px] relative`}>
                  <img
                    src={event.image}
                    alt={event.title}
                    className={`w-full ${window.innerWidth <= 768 ? "h-[200px]" : "h-[250px]"} object-cover p-3`}
                    style={{ borderRadius: "30px" }}
                  />
                </div>
                <div className={`w-full ${index % 2 !== 0 ? 'md:order-1' : ''} p-4 md:p-6`}>
                  <h3 className='text-xl font-bold text-gray-800 mb-2'>
                    {event.title}
                  </h3>
                  <div className='flex flex-wrap items-center text-gray-500 text-sm mb-4'>
                    <div className='flex items-center mr-4 mb-2 md:mb-0'>
                      <svg className='w-4 h-4 mr-1.5' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
                        <path strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' d='M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z' />
                      </svg>
                      {event.date}
                    </div>
                    <div className='flex items-center'>
                      <svg className='w-4 h-4 mr-1.5' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
                        <path strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' d='M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z' />
                      </svg>
                      {event.attendees} attendees
                    </div>
                  </div>
                  <p className='text-gray-600 text-sm md:text-base leading-relaxed mb-4'>
                    {event.description.length > 500
                      ? `${event.description.slice(0, 300)}...`
                      : event.description}
                  </p>
                  <div className='flex justify-start md:justify-start'>
                    <button
                      className='text-[#0d73b9] text-sm font-medium hover:text-blue-700 transition-colors flex items-center'
                      onClick={() => navigate(`/event/${event.id}`)}
                    >
                      Learn More
                      <ArrowRight className='ml-2' />
                    </button>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
          {window.innerWidth <= 768 && RECENT_EVENTS.length > 2 && (
            <div className='mt-6 md:mt-8 text-center'>
              <button
                onClick={() => setShowAll(!showAll)}
                className='bg-white text-[#0d73b9] px-6 py-2 rounded-full font-medium hover:bg-opacity-90 transition-all flex items-center mx-auto'
              >
                {showAll ? 'See Less' : 'See More'}
                <ArrowRight className={`ml-2 transition-transform ${showAll ? 'rotate-180' : ''}`} />
              </button>
            </div>
          )}
        </div>
      </section> */}
        {/* ================= VOLUNTEER CTA ================= */}

        <section className="bg-[#F5F5F5] py-6 md:py-10 px-3 md:px-5">
          <div
            className="relative overflow-hidden w-full mx-auto text-center"
            style={{
              background: "linear-gradient(135deg, #0078BF 0%, #244183 100%)",
              borderRadius: "20px",
              boxShadow: "0 12px 35px rgba(36, 65, 131, 0.18)",
            }}
          >
            {/* Decorative Circle - Right */}
            <div
              style={{
                position: "absolute",
                width: "250px",
                height: "250px",
                borderRadius: "50%",
                background: "rgba(255,255,255,0.07)",
                top: "-140px",
                right: "-60px",
              }}
            />

            {/* Decorative Circle - Left */}
            <div
              style={{
                position: "absolute",
                width: "180px",
                height: "180px",
                borderRadius: "50%",
                background: "rgba(255,255,255,0.05)",
                bottom: "-110px",
                left: "-40px",
              }}
            />

            {/* Content */}
            <div className="relative z-10 px-4 py-8 md:py-10">

              <span
                className="inline-block mb-3"
                style={{
                  padding: "6px 15px",
                  borderRadius: "50px",
                  background: "rgba(255,255,255,0.13)",
                  border: "1px solid rgba(255,255,255,0.22)",
                  color: "#fff",
                  fontSize: "0.75rem",
                  fontWeight: "600",
                  letterSpacing: "1px",
                }}
              >
                JOIN OUR COMMUNITY
              </span>

              <h2 className="text-2xl md:text-4xl font-bold text-white mb-3">
                Make an Impact with APCCI
              </h2>

              <p
                className="text-sm md:text-base mx-auto mb-5"
                style={{
                  maxWidth: "700px",
                  color: "rgba(255,255,255,0.88)",
                  lineHeight: "1.7",
                }}
              >
                Join our volunteer community, contribute your skills and ideas,
                and become a part of the people shaping APCCI's growing ecosystem.
              </p>

              <a
                href="https://zfrmz.in/HddRHS5u2OczpMZXxwGH"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-3 font-bold"
                style={{
                  background: "#fff",
                  color: "#244183",
                  padding: "13px 22px",
                  borderRadius: "12px",
                  textDecoration: "none",
                  fontSize: "clamp(0.88rem, 2vw, 1rem)",
                  boxShadow: "0 8px 24px rgba(0,0,0,0.16)",
                  transition: "all 0.3s ease",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-3px)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                }}
              >
                Become an APCCI Volunteer

                <span
                  className="inline-flex items-center justify-center"
                  style={{
                    width: "30px",
                    height: "30px",
                    borderRadius: "50%",
                    background: "linear-gradient(135deg, #0078BF, #244183)",
                    color: "#fff",
                    fontSize: "18px",
                  }}
                >
                  →
                </span>
              </a>

            </div>
          </div>
        </section>


        {/* FAQ Section */}
        <div className='bg-[#F5F5F5] lg:p-20 md:p-20 sm:p-0'>
          <div className='  max-w-8xl justify-center p-8 sm:text-2x ' style={{ background: " linear-gradient(180deg, #0078BF 0%, #244183 100%)", borderRadius: window.innerWidth > 768 ? "20px" : "0px" }}>
            <div className='max-w-7xl mx-auto '  >
              <div className='text-center mb-12'>
                <h2 className='text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-4' style={{ fontFamily: "Poppins", }}>
                  Frequently Asked Questions
                </h2>
                <p className='text-base text-white sm:text-lg md:text-xl text-center' style={{
                  fontFamily: "Poppins",
                  fontStyle: "normal",
                  fontWeight: "400",
                  lineHeight: "28px",
                  color: "#FFFFFF",

                }}>
                  Find answers to common questions about our services
                </p>
              </div>

              <div className='space-y-6 ' >
                {FAQ_ITEMS.map((item, index) => (
                  <div
                    key={index}
                    className='bg-white rounded-xl shadow-lg overflow-hidden transform transition-all duration-200 hover:scale-[1.02]'
                  >
                    <button
                      onClick={() => toggleAccordion(index)}
                      className={`w-full px-8 py-2 text-left flex justify-between items-center transition-colors ${activeIndex === index ? 'bg-blue-50' : 'hover:bg-gray-50'
                        }`}
                    >
                      <span className='text-base sm:text-lg md:text-xl font-medium text-gray-900 flex items-center'>
                        {item.question}
                      </span>
                      <span
                        className={`text-2xl transform transition-all duration-300 ${activeIndex === index
                          ? 'rotate-180 text-blue-500'
                          : 'text-gray-400'
                          }`}
                      >
                        <svg viewBox="0 0 56 52" className="w-10 h-10 sm:w-12 sm:h-12 md:w-14 md:h-14" xmlns="http://www.w3.org/2000/svg">
                          <g filter="url(#filter0_dd_7_2742)">
                            <circle cx="28" cy="26" r="24" fill="white" />
                            <circle cx="28" cy="26" r="24" fill="url(#paint0_linear_7_2742)" />
                          </g>
                          <g clip-path="url(#clip0_7_2742)">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.052 20.4573L19.5093 27.9999L21.3946 29.8853L27.9946 23.2853L34.5946 29.8853L36.48 27.9999L28.9373 20.4573C28.6873 20.2073 28.3482 20.0669 27.9946 20.0669C27.6411 20.0669 27.302 20.2073 27.052 20.4573Z" fill="white" />
                          </g>
                          <defs>
                            <filter id="filter0_dd_7_2742" x="0" y="0" width="56" height="56" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                              <feFlood flood-opacity="0" result="BackgroundImageFix" />
                              <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                              <feOffset dy="2" />
                              <feGaussianBlur stdDeviation="2" />
                              <feComposite in2="hardAlpha" operator="out" />
                              <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
                              <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_7_2742" />
                              <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                              <feOffset dy="2" />
                              <feGaussianBlur stdDeviation="2" />
                              <feComposite in2="hardAlpha" operator="out" />
                              <feColorMatrix type="matrix" values="0 0 0 0 0.14244 0 0 0 0 0.249747 0 0 0 0 0.571667 0 0 0 0.14 0" />
                              <feBlend mode="normal" in2="effect1_dropShadow_7_2742" result="effect2_dropShadow_7_2742" />
                              <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_7_2742" result="shape" />
                            </filter>
                            <linearGradient id="paint0_linear_7_2742" x1="28" y1="2" x2="28" y2="56.4" gradientUnits="userSpaceOnUse">
                              <stop stop-color="#0078BF" />
                              <stop offset="1" stop-color="#244183" />
                            </linearGradient>
                            <clipPath id="clip0_7_2742">
                              <rect width="16" height="32" fill="white" transform="matrix(0 -1 -1 0 44 34)" />
                            </clipPath>
                          </defs>
                        </svg>


                      </span>
                    </button>

                    <div
                      className={`transition-all duration-300 ease-in-out ${activeIndex === index
                        ? 'max-h-96 opacity-100'
                        : 'max-h-0 opacity-0'
                        }`}
                    >
                      <div className='px-8 py-3 border-t border-gray-100 bg-gradient-to-r from-blue-50/50 to-purple-50/50'>
                        <p className='text-gray-600 text-sm sm:text-base md:text-lg leading-relaxed sm:leading-relaxed md:leading-loose'>
                          {item.answer}
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>


            </div>
          </div>
        </div>
      </motion.div >
      <Footer />
    </>
  )
}

export default Home
